<script>
    import { findings } from "../../routes/finding/findings.state.svelte.js";
    import { format } from "svelte-i18n";
    import AssetsApi from "../../routes/asset/assets.api.js";
    import AssetDetailExpanded from "../../routes/finding/_components/asset-detail-expanded.svelte";
    // 1. Import native Svelte transitions instead of Bootstrap JS
    import { fade, fly } from "svelte/transition";

    let { value, rowIndex, rowId, instructKey } = $props();

    let isModalOpen = $state(false);
    let modalAssetData = $state(null);

    let data = $derived(value);

    const openAssetModal = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        modalAssetData = data.asset;
        isModalOpen = true;

        // 2. Replicate Bootstrap's body scroll lock
        document.body.classList.add("modal-open");
    };

    const closeModal = () => {
        isModalOpen = false;
        document.body.classList.remove("modal-open");

        setTimeout(() => {
            modalAssetData = null;
        }, 300);
    };

    // 3. Handle closing via the Escape key natively
    function handleKeydown(e) {
        if (e.key === "Escape" && isModalOpen) {
            closeModal();
        }
    }
</script>

<svelte:window onkeydown={handleKeydown} />

{#if data}
    {#if !findings.list.loading}
        <button
            class="asset-modal-btn"
            onclick={openAssetModal}
            title={data.title}
            >{data.label}<i
                class={"ms-2 fa-xs " + AssetsApi.AssetsIcons[data.kind]}
            ></i></button
        >
        <a href={`${data.path}/${data["id"]}`}
            ><i class="fas fa-external-link-alt"></i></a
        >
    {:else}
        <div><i class="fas fa-sync-alt fa-spin"></i></div>
    {/if}
{/if}
{#if findings.list.loading}
    <div><i class="fas fa-sync-alt fa-spin"></i></div>
{/if}

<!-- NATIVE SVELTE MODAL -->
{#if isModalOpen && data}
    <!-- 4. Native Backdrop -->
    <div class="modal-backdrop show" transition:fade={{ duration: 150 }}></div>

    <!-- 5. Native Modal Wrapper (Clicking this dark area closes the modal) -->
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
    <div
        class="modal show d-block"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        onclick={closeModal}
        transition:fade={{ duration: 150 }}
    >
        <!-- 6. Stop click propagation here so clicking the white box doesn't close it -->
        <div
            class="modal-dialog"
            onclick={(e) => e.stopPropagation()}
            role="document"
        >
            <div
                class="modal-content"
                transition:fly={{ y: -20, duration: 200 }}
            >
                <div class="modal-header">
                    {#if data.kind}
                        <h4 class="modal-title">
                            {$format("asset_summary")} ({$format(
                                "asset.kind." + data.kind + ".singular",
                            )})
                        </h4>
                    {/if}
                    <button
                        type="button"
                        class="btn-close"
                        onclick={closeModal}
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    {#if modalAssetData}
                        <AssetDetailExpanded asset={modalAssetData} />
                    {/if}
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .asset-modal-btn {
        background-color: transparent !important;
        border: none !important;
    }

    a i.fa-external-link-alt {
        position: relative;
        top: -2px;
        font-size: 0.75rem;
    }

    /* Required for Svelte's transition to match Bootstrap's CSS opacity */
    .modal-backdrop.show {
        opacity: 0.5;
    }
</style>
